import axios from 'axios'
import Utils from '../utils/utils'
import vue from 'vue'

export async function getSanxianStationData(condition = {}) {
    let response = {}
    try {
        response = await vue.http.get('/api/weather')

    } catch (err) {
        console.error('iisi getSanxianStationData: ', err)
        return null
    }

    return handleSanxianStationData(response)
}

function handleSanxianStationData(response) {
    let result = {}
    const data = response.data

    if (Utils.isEmptyObject(data)) {
        return null
    }

    for (let i = 0; i < data.length; i++) {
        const key = data[i].dataType.replace(/\s+/g, '') // remove space in string
        result[key] = data[i].dataInfo
    }

    return result

}